export const lineItemsRoutes = {
  path: '/line-items',
  children: [
    {
      name: 'lineItems',
      path: '',
      component: () => import('pages/LineItems/LineItems/index.vue'),
      meta: {
        title: 'Line Items',
      },
    },
    {
      name: 'newLineItem',
      path: 'new',
      component: () => import('pages/LineItems/NewLineItem/index.vue'),
      meta: {
        title: 'New Line Item',
      },
    },
    {
      name: 'editLineItem',
      path: ':id/edit',
      component: () => import('pages/LineItems/EditLineItem/index.vue'),
      meta: {
        title: 'Edit Line Item',
      },
    },
  ],
}
